import {NgModule} from '@angular/core';
import { FlightOffersComponent } from './flight-offers.component';
import {CommonModule} from '@angular/common';
import { FavoritesModule } from '@shopping-angular-components/favorites';
import { SliderProModule } from '../slider-pro/slider-pro.module';
import { BaggagesWrapperModule } from '../offers/baggages-wrapper/baggages-wrapper.module';
import { TranslateModule } from '@ngx-translate/core';
import { TextModule } from '../text/text.module';
import { UserFavoritesModule } from '../user-favorites/user-favorites.module';
import { OffersModule } from '../offers/offers.module';

@NgModule({
    declarations: [
        FlightOffersComponent
    ],
    imports: [
        CommonModule,
        FavoritesModule,
        SliderProModule,
        BaggagesWrapperModule,
        TranslateModule,
        TextModule,
        UserFavoritesModule,
        OffersModule,
    ],
    exports: [
        FlightOffersComponent
    ]
})

export class FlightOffersModule{

}
